// @flow

import { getProps } from '../props';
import { getDirectoryTree } from '../../../HttpRequests/files';
import { loadRootDirectories } from '../State/rootDirectories';
import handleException from '../../../Core/Helpers/handleException';
import { setFetchingRootDirectories } from '../State/fetchingRootDirectories';
import { setCurrentDirectoryPath } from '../State/currentDirectoryPath';
import fetchDirectory from './fetchDirectory';

export default () => async (dispatch: Function, getState: Function) => {

  dispatch(setFetchingRootDirectories(true));

  try {
    
    const projectId = getProps().match.params.id

    const params = {
      path: `Projects/${projectId}`
    }

    const response = await getDirectoryTree({ params });

    const tree = response.data.data;

    dispatch(loadRootDirectories(tree));

    if (!getState().screens.ProjectView.currentDirectoryPath && tree.length > 0) {
      dispatch(setCurrentDirectoryPath(tree[0].path));
      dispatch(fetchDirectory());
    }

  } catch (error) {

    handleException(error);

  }

  dispatch(setFetchingRootDirectories(false));
}